/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../../action';
import { const_var, params } from '../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../../utils/Functions';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../CustomMaterial';

const TrimModel = () => {
    const dispatch = useDispatch();

    const [frontWallCloseSize, setFrontWallCloseSize] = useState(0);
    const [backWallCloseSize, setBackWallCloseSize] = useState(0);
    const [rightWallCloseSize, setRightWallCloseSize] = useState(0);
    const [leftWallCloseSize, setLeftWallCloseSize] = useState(0);

    const wallThickness = 0.005;

    const frontJTrimState = params.p_j_t_end && params.p_b_c_b_l_f !== "Open" && params.p_b_c_b_l_f !== "Close";
    const backJTrimState = params.p_j_t_end && params.p_b_c_b_l_b !== "Open" && params.p_b_c_b_l_b !== "Close";
    const rightJTrimState = params.p_j_t && params.p_b_c_b_l_r !== "Open" && params.p_b_c_b_l_r !== "Close" && params.p_b_c_b_l_r !== "Half Dutch End" && params.p_b_c_b_l_r !== "Half End";
    const leftJTrimState = params.p_j_t && params.p_b_c_b_l !== "Open" && params.p_b_c_b_l !== "Close" && params.p_b_c_b_l !== "Half Dutch End" && params.p_b_c_b_l !== "Half End";
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined])
    
    const offset = useMemo(() => {
        if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage)) {
            return 0;
        } else if (params.leftLeanStoragePosition === 0) {
            return 0.5;
        } else {
            return 0.5;
        }
    }, [params.lean_p_d, legDistance, params.leftLeanStoragePosition, params.add_storage]);
    

    // const dutchDelModelFront = useMemo(() => {
    //     const freeSpace = 1;
    //     const trimWidth = 0.2;
    //     const offset = 0.05 * Math.pow(2, 1 / 2)
    //     let cornerFreeSpaceW = (params.lean_p_d - freeSpace) / 6;
    //     let cornerFreeSpaceH = (params.lean_p_h - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_left_lean && (params.p_b_c_b_l_f === "Half Dutch End" || params.p_b_c_b_l_f === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.lean_p_d / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_l_f === "Half Dutch End") {
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.lean_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.lean_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //         } else {
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - trimWidth);
    //         }
    //         model.lineTo(-(params.lean_p_d / 2 - freeSpace - trimWidth), 0);
    //         model.closePath()

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_left_lean, params.lean_p_d, params.lean_p_h, params.p_b_c_b_l_f])

    // const dutchDelModelBack = useMemo(() => {
    //     const freeSpace = 1;
    //     const trimWidth = 0.2;
    //     const offset = 0.05 * Math.pow(2, 1 / 2)
    //     let cornerFreeSpaceW = (params.lean_p_d - freeSpace) / 6;
    //     let cornerFreeSpaceH = (params.lean_p_h - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_left_lean && (params.p_b_c_b_l_b === "Half Dutch End" || params.p_b_c_b_l_b === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.lean_p_d / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_l_b === "Half Dutch End") {
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.lean_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.lean_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //         } else {
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), params.lean_p_h - freeSpace);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.lean_p_d / 2 - freeSpace - trimWidth), params.lean_p_h - freeSpace - trimWidth);
    //         }
    //         model.lineTo(-(params.lean_p_d / 2 - freeSpace - trimWidth), 0);
    //         model.closePath()

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_left_lean, params.lean_p_d, params.lean_p_h, params.p_b_c_b_l_b])
    
    const frontLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l_f === "Open" || params.p_b_c_b_l_f === "Gable")) {
            model.moveTo(params.lean_p_w / 2 + 0, frontWallCloseSize);
            model.lineTo(params.lean_p_w / 2 + 0, params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(params.lean_p_w / 2 + 0.23, params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(params.lean_p_w / 2 + 0.23, frontWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.lean_p_h, params.lean_p_w, frontWallCloseSize, params.p_b_c_b_l_f, params.b_l_t_r_p])
    
    const frontRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l_f === "Open" || params.p_b_c_b_l_f === "Gable")) {
            model.moveTo(-(params.lean_p_w / 2 + 0.235), frontWallCloseSize);
            model.lineTo(-(params.lean_p_w / 2 + 0.235), params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(-(params.lean_p_w / 2 + 0), params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(-(params.lean_p_w / 2 + 0), frontWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.lean_p_h, params.lean_p_w, frontWallCloseSize, params.p_b_c_b_l_f, params.b_l_t_r_p])
    
    const rightWallLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l_r === "Open" || params.p_b_c_b_l_r === "Gable")) {
            model.moveTo(-(params.lean_p_w / 2 ), params.lean_p_h);
            model.lineTo(-(params.lean_p_w / 2 ), rightWallCloseSize);
            model.lineTo(-(params.lean_p_w / 2 + 0.235), rightWallCloseSize);
            model.lineTo(-(params.lean_p_w / 2 + 0.235), params.lean_p_h);
            model.closePath();
        }

        return model;
    }, [rightWallCloseSize, params.p_b_c_b_l, params.lean_p_w, params.lean_p_h, params.lean_p_d, params.p_b_c_b_l_f])
    
    const leftWallRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l === "Open" || params.p_b_c_b_l === "Gable")) {
            model.moveTo((params.lean_p_w / 2 ), params.lean_p_h);
            model.lineTo((params.lean_p_w / 2 ), leftWallCloseSize);
            model.lineTo((params.lean_p_w / 2 + 0.235), leftWallCloseSize);
            model.lineTo((params.lean_p_w / 2 + 0.235), params.lean_p_h);
            model.closePath();
        }

        return model;
    }, [leftWallCloseSize, params.p_b_c_b_l, params.lean_p_w, params.lean_p_h, params.lean_p_d, params.p_b_c_b_l_f])

    const backLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l_b === "Open" || params.p_b_c_b_l_b === "Gable")) {
            model.moveTo(-(params.lean_p_w / 2 + 0.235), backWallCloseSize);
            model.lineTo(-(params.lean_p_w / 2 + 0.235), params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(-(params.lean_p_w / 2 + 0), params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(-(params.lean_p_w / 2 + 0), backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.lean_p_h, params.lean_p_w, backWallCloseSize, params.p_b_c_b_l_b, params.b_l_t_r_p])

    const backRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l_b === "Open" || params.p_b_c_b_l_b === "Gable")) {
            model.moveTo(params.lean_p_w / 2 + 0, backWallCloseSize);
            model.lineTo(params.lean_p_w / 2 + 0, params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(params.lean_p_w / 2 + 0.23, params.lean_p_h - (params.b_l_t_r_p / 12 * 0.1));
            model.lineTo(params.lean_p_w / 2 + 0.23, backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.lean_p_h, params.lean_p_w, backWallCloseSize, params.p_b_c_b_l_b, params.b_l_t_r_p])

    const frontWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.lean_p_w + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
            
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(params.lean_p_w / 2 + 0.15), frontWallCloseSize + 0.1, 0.0625)
        meshJTrimModel_Temp.rotation.y = Math.PI/2
        meshJTrimModel_Temp.updateMatrixWorld()
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.lean_p_pos, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG_Temp,new THREE.Matrix4())

        main = CSGJTrimModel.geometry

        // wainscot trim
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_w + 0.02)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set(-(params.lean_p_w / 2 + 0.02), 3 , 0.06)
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [params.lean_p_w, frontWallCloseSize, params.lean_p_pos, params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.p_b_c_b_l, params.add_storage_check, params.add_storage, params.lean_p_h, const_var.newDoorsArray])

    const backWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.lean_p_w + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
            
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set((params.lean_p_w / 2 + 0.15), backWallCloseSize + 0.1, params.lean_p_d + 0.0625);
        meshJTrimModel_Temp.rotation.y = -Math.PI/2;
        meshJTrimModel_Temp.updateMatrixWorld();
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.lean_p_pos, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG_Temp,new THREE.Matrix4())

        main = CSGJTrimModel.geometry

        // wainscot trim
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_w + 0.3)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set((params.lean_p_w / 2 + 0.15), 3 , params.lean_p_d + 0.06);
        meshWainscotTrimModel_Temp.rotation.y = -Math.PI/2;
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [params.lean_p_w, backWallCloseSize, params.lean_p_pos, params.lean_p_d, params.p_b_c_b_l, params.add_storage_check, params.add_storage, params.lean_p_h, const_var.newDoorsArray])
    
    const rightWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;

        const storageDelModelSizeOffset = params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage) ? 0 : 0.35

        const storageRightWallModel = new THREE.Shape();
        storageRightWallModel.moveTo(-(params.p_w / 2 - 0.15), params.lean_p_h);                          
        storageRightWallModel.lineTo(-(params.p_w / 2 - storageDelModelSizeOffset + parseInt(params.add_storage) + offset), params.lean_p_h);        
        storageRightWallModel.lineTo(-(params.p_w / 2 - storageDelModelSizeOffset + parseInt(params.add_storage) + offset), 0);  
        storageRightWallModel.lineTo(-(params.p_w / 2 - 0.15), 0);                    
        storageRightWallModel.closePath();

        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.lean_p_d)), new THREE.MeshStandardMaterial({color: 'red'}))
        const storageRightWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageRightWallModel, extrudeSettings(1)));
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(params.lean_p_w / 2 + 0.1525), rightWallCloseSize + 0.1, params.lean_p_d + 0.06)
        meshJTrimModel_Temp.rotation.y = Math.PI
        meshJTrimModel_Temp.updateMatrixWorld()

        let storageRightWallDelModel_Temp = storageRightWallDelModel.clone();
        storageRightWallDelModel_Temp.rotateY(-Math.PI / 2);
        storageRightWallDelModel_Temp.position.set(-params.lean_p_w / 2 + 0.5, 0, params.lean_p_d + params.p_w / 2 - params.leftLeanStoragePosition);
        storageRightWallDelModel_Temp.updateMatrixWorld();

        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.lean_p_w / 2 + 0.5, 0, params.lean_p_d + params.p_w / 2);
        meshDelModel_Temp.rotation.y = -Math.PI / 2;
        meshDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const storageRightWallDelModel_CSG = CSG.fromMesh(storageRightWallDelModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        let storageJTrimDelModel;
        if(params.add_storage_check){
            storageJTrimDelModel = meshJTrimModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else {
            storageJTrimDelModel = meshJTrimModel_CSG;
        }
        const JTrimDelModel_CSG = storageJTrimDelModel.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimDelModel_CSG,new THREE.Matrix4())
        main = CSGJTrimModel.geometry
        
        // wainscot trim
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_d + 0.01)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(-(params.lean_p_w / 2 + 0.155), 3 , (params.lean_p_d) + 0.06)
        meshWainscotModel_Temp.rotation.y = Math.PI
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);

        let storageWainscotTrimDelModel;
        if(params.add_storage_check){
            storageWainscotTrimDelModel = meshWainscotModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else {
            storageWainscotTrimDelModel = meshWainscotModel_CSG;
        }

        const wainscotModel_CSG = storageWainscotTrimDelModel.subtract(meshDelModel_CSG);

        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG,new THREE.Matrix4())
        wainscot = CSGWainscotModel.geometry

        return {main, wainscot}
    }, [params.lean_p_d, params.lean_p_w, params.p_w, rightWallCloseSize, offset, params.leftLeanStoragePosition, const_var.newDoorsArray, params.lean_p_pos, params.add_storage_check, params.add_storage])

    const leftWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;

        const storageDelModelSizeOffset = params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage) ? 0 : 0.3
        
        const storageLeftWallModel = new THREE.Shape();
        storageLeftWallModel.moveTo(-(params.p_w / 2 - 0.15), params.lean_p_h);                         
        storageLeftWallModel.lineTo(-(params.p_w / 2 - storageDelModelSizeOffset + parseInt(params.add_storage) + offset), params.lean_p_h);      
        storageLeftWallModel.lineTo(-(params.p_w / 2 - storageDelModelSizeOffset + parseInt(params.add_storage) + offset), 0); 
        storageLeftWallModel.lineTo(-(params.p_w / 2 - 0.15), 0);                    
        storageLeftWallModel.closePath();

        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.lean_p_d)), new THREE.MeshStandardMaterial({color: 'red'}))
        const storageLeftWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageLeftWallModel, extrudeSettings(1)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanLeft', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))

        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set((params.lean_p_w / 2 + 0.1525), leftWallCloseSize + 0.1, 0.06)
        meshJTrimModel_Temp.updateMatrixWorld();

        let storageLeftWallDelModel_Temp = storageLeftWallDelModel.clone();
        storageLeftWallDelModel_Temp.rotateY(Math.PI / -2);
        storageLeftWallDelModel_Temp.position.set((params.lean_p_w / 2) + 0.5, 0, (params.lean_p_d) + params.p_w / 2 - params.leftLeanStoragePosition + 0.05);
        storageLeftWallDelModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotateY(Math.PI / -2);
        meshDelModel_Temp.position.set((params.lean_p_w / 2) + 0.5, 0, (params.lean_p_d) + params.p_w / 2 + 0.05);
        meshDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const storageLeftWallDelModel_CSG = CSG.fromMesh(storageLeftWallDelModel_Temp);
    
        let storageJTrimDelModel;
        if(params.add_storage_check){
            storageJTrimDelModel = meshJTrimModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            storageJTrimDelModel = meshJTrimModel_CSG;
        }
        const JTrimModel_CSG = storageJTrimDelModel.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG,new THREE.Matrix4());
        main = CSGJTrimModel.geometry;

        // wainscot trim
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_d)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set((params.lean_p_w / 2 + 0.155), 3 , 0.05)
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);

        let storageWainscotTrimDelModel;
        if(params.add_storage_check){
            storageWainscotTrimDelModel = meshWainscotModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            storageWainscotTrimDelModel = meshWainscotModel_CSG;
        }
    
        const wainscotModel_CSG = storageWainscotTrimDelModel.subtract(meshDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG, new THREE.Matrix4());
        wainscot = CSGWainscotModel.geometry;

        return {main, wainscot}
    }, [params.lean_p_d, params.lean_p_w, params.p_w, const_var.newDoorsArray, leftWallCloseSize, params.leftLeanStoragePosition, params.lean_p_pos, params.add_storage_check, params.add_storage])

    // --- left wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_l === 'Open' || typeof(params.p_b_c_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.lean_p_h - 0.25;
            } else {
                tempWallCloseSize = params.lean_p_h;
            }
        } else if (params.p_b_c_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4 * 3;
        } else if (params.p_b_c_b_l === "Half_Close") {
            tempWallCloseSize = params.lean_p_h / 2;
        } else if (params.p_b_c_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4;
        } else if (params.p_b_c_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.lean_p_h - 3 * params.p_b_c_b_l;
        }

        setLeftWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'LLLeftWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_l, params.lean_p_h, params.p_r_s])

    // --- right wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_l_r === 'Open' || typeof(params.p_b_c_b_l_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.lean_p_h - 0.25;
            } else {
                tempWallCloseSize = params.lean_p_h;
            }
        } else if (params.p_b_c_b_l_r === "One_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4 * 3;
        } else if (params.p_b_c_b_l_r === "Half_Close") {
            tempWallCloseSize = params.lean_p_h / 2;
        } else if (params.p_b_c_b_l_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4;
        } else if (params.p_b_c_b_l_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.lean_p_h - 3 * params.p_b_c_b_l_r;
        }

        setRightWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'LLRightWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_l_r, params.lean_p_h, params.p_r_s])
    
    // --- front wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.p_b_c_b_l_f === "One_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4 * 3;
        } else if (params.p_b_c_b_l_f === "Gable") {
            tempWallCloseSize = params.lean_p_h - 0.2;
        } else if (params.p_b_c_b_l_f === "Half_Close") {
            tempWallCloseSize = params.lean_p_h / 2;
        } else if (params.p_b_c_b_l_f === "Three_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4;
        } else if (params.p_b_c_b_l_f === "Close") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_l_f === "Half Dutch End") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_l_f === "Half End") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = -1;
        }

        setFrontWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_l_f, params.lean_p_h, params.p_r_s])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_l_b === "One_Fourth_Close") {
                tempWallCloseSize = params.lean_p_h / 4 * 3;
            } else if (params.p_b_c_b_l_b === "Gable") {
                tempWallCloseSize = params.lean_p_h - 0.2;
            } else if (params.p_b_c_b_l_b === "Half_Close") {
                tempWallCloseSize = params.lean_p_h / 2;
            } else if (params.p_b_c_b_l_b === "Three_Fourth_Close") {
                tempWallCloseSize = params.lean_p_h / 4;
            } else if (params.p_b_c_b_l_b === "Half End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_l_b === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_l_b === "Close") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setBackWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'LLBackWallCloseState': tempWallCloseSize}))
    }, [params.add_storage_check, params.p_b_c_b_l_b, params.lean_p_h, params.p_r_s])

    return (
        <>
            <group position={[-(params.p_w / 2 + params.lean_p_d + 0.05 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
                <mesh name="right-wall-left-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[rightWallLeftVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableLeftLean"} />
                </mesh>
                <mesh name="left-wall-right-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[leftWallRightVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableLeftLean"} />
                </mesh>
                <mesh name="front-wall-left-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[frontLeftVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableLeftLean"} />
                </mesh>
                <mesh name="front-wall-right-trim"position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[frontRightVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableLeftLean"} />
                </mesh>
                <group position={[0,0, params.lean_p_d - 0.05]}>
                    {(params.lean_p_pos !== (params.p_d - params.lean_p_w) / 2 || (params.lean_p_pos === (params.p_d - params.lean_p_w) / 2 && params.p_f_w === 'Open')) &&
                    <>
                        <mesh name="right-wall-right-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[rightWallLeftVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableLeftLean"} />
                        </mesh>
                        <mesh name="back-wall-left-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[backLeftVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableLeftLean"} />
                        </mesh>
                    </>}
                    {(params.lean_p_pos !== -(params.p_d - params.lean_p_w) / 2 || (params.lean_p_pos === -(params.p_d - params.lean_p_w) / 2 && params.p_b_w === 'Open')) &&
                    <>
                        <mesh name="left-wall-left-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[leftWallRightVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableLeftLean"} />
                        </mesh>
                        <mesh name="back-wall-right-trim"position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[backRightVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableLeftLean"} />
                        </mesh>
                    </>}
                </group>

                {frontJTrimState &&
                    <mesh name="front-wall-J-trim" geometry={frontWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableLeftLean"} />
                    </mesh>
                }
                {backJTrimState &&
                    <mesh name="back-wall-J-trim" geometry={backWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableLeftLean"} />
                    </mesh>
                }
                {rightJTrimState &&
                    <mesh name="right-wall-J-trim" geometry={rightWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableLeftLean"} />
                    </mesh>
                }
                {leftJTrimState &&
                    <mesh name="side-wall-J-trim" geometry={leftWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableLeftLean"} />
                    </mesh>
                }

                {params.p_w_c_n === true && params.p_b_c_b_l_f === "Close" &&
                    <mesh name="G_L_L_F_W_wainscotTrim" geometry={frontWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableLeftLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_l_w !== 'Close' && params.p_b_c_b_l_b === "Close" &&  
                    <mesh name="G_L_L_B_W_wainscotTrim" geometry={backWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableLeftLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_l_r === "Close" &&
                    <mesh name="G_L_L_R_W_wainscotTrim" geometry={rightWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableLeftLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_l === "Close" &&
                    <mesh name="G_L_L_L_W_wainscotTrim" geometry={leftWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableLeftLean"}  />
                    </mesh>
                }
            </group>

            {/* <mesh position={[ -(params.lean_p_d / 2 + params.p_w / 2), 0, params.lean_p_w / 2 + 0.1]} >
                <extrudeGeometry args={[dutchDelModelFront, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"gableLeftLean"} />
            </mesh>
            <mesh position={[ -(params.lean_p_d / 2 + params.p_w / 2), 0, - (params.lean_p_w / 2 + 0.25)]} >
                <extrudeGeometry args={[dutchDelModelBack, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"gableLeftLean"} />
            </mesh> */}
        </>
    )
}

export default TrimModel